import { useQuery } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";

interface JiraTicket {
  id: string;
  key: string;
  fields: {
    summary: string;
    status: {
      name: string;
      statusCategory: {
        name: string;
        colorName: string;
      };
    };
    assignee?: {
      displayName: string;
      avatarUrls: {
        "48x48": string;
      };
    };
    created: string;
    updated: string;
    description?: string;
    priority?: {
      name: string;
    };
  };
}

interface JiraTicketSearchResponse {
  issues: JiraTicket[];
  total: number;
  maxResults: number;
  startAt: number;
}

const useJiraTicketSearch = (enabled: boolean = true) => {
  return useQuery<JiraTicketSearchResponse, Error>(
    ["jiraTicketSearch"],
    () => {
      return servicesUtils.getService<JiraTicketSearchResponse>("/jira_ticket/search/");
    },
    {
      enabled: enabled,
      staleTime: 2 * 60 * 1000, // Cache for 2 minutes
      retry: 1,
    }
  );
};

export default useJiraTicketSearch;
export type { JiraTicket, JiraTicketSearchResponse };
